import client from './client';
import { getApiBaseUrl } from '../config/env';
import axios from 'axios';

/**
 * Admin aptitude test CRUD - /api/aptitude-tests
 */
export const listAptitudeTests = (params = {}) =>
  client.get('/api/aptitude-tests', { params });

export const getAptitudeTest = (id) =>
  client.get(`/api/aptitude-tests/${id}`);

export const createAptitudeTest = (payload) =>
  client.post('/api/aptitude-tests', payload);

export const addAptitudeQuestion = (testId, payload) =>
  client.post(`/api/aptitude-tests/${testId}/questions`, payload);

/**
 * Public candidate endpoints - /v1/aptitude (no auth required)
 */
const publicClient = axios.create({
  baseURL: getApiBaseUrl(),
  headers: { 'Content-Type': 'application/json' },
  timeout: 30_000,
});

export const resolveAptitudeTest = (token) =>
  publicClient.get('/v1/aptitude/resolve', { params: { token } });

export const startAptitudeTest = (token) =>
  publicClient.post('/v1/aptitude/start', null, { params: { token } });

export const submitAptitudeTest = (token, answers) =>
  publicClient.post('/v1/aptitude/submit', { answers }, { params: { token } });
